import styled, { css } from 'styled-components';

export type ExcelIconStyledProps = {
  isDisabled?: boolean;
};

export const ExcelIconStyled = styled.div<ExcelIconStyledProps>`
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      svg path {
        fill: var(--ds-icon-disabled, var(--ds-fb-icon-disabled));
      }
    `}
`;
